import { useEffect, useState } from 'react';

import { noop } from '@/utils';

export const useDebounce = <T = string>(
  value: T,
  callback: (v: T) => void = noop,
  milliSeconds = 250,
) => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
      callback(value);
    }, milliSeconds);

    return () => {
      clearTimeout(handler);
    };
  }, [value, milliSeconds]);

  return debouncedValue;
};
